export const required = customMessage => value => (value
    ? undefined
    : customMessage || 'This field is required');

export const maxLength = (max, customMessage) => value =>
  value && value.length > max
    ? customMessage || `This field must must be ${max} characters or less`
    : undefined;

export const minLength = (min, customMessage) => value =>
  value && value.length < min
    ? customMessage || `This field must be ${min} characters or more`
    : undefined;

export const email = customMessage => value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? customMessage || 'This email address is invalid'
    : undefined;

export const username = customMessage => (value) =>
  !value.match(/^[a-z0-9_\-]+$/gi)
    ? customMessage || 'Given username is not a valid format. Try only using letters, numbers, hyphens -, underscores (_) and no spaces in between'
    : undefined;



// WEBPACK FOOTER //
// ./src/utils/validators.js